/* import __COLOCATED_TEMPLATE__ from './upvote-button.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type CommunityCourseStageSolutionModel from 'codecrafters-frontend/models/community-course-stage-solution';
import type AuthenticatorService from 'codecrafters-frontend/services/authenticator';

interface Signature {
  Element: HTMLButtonElement;

  Args: {
    metadata?: Record<string, unknown>;
    solution: CommunityCourseStageSolutionModel;
  };
}

export default class UpvoteButtonComponent extends Component<Signature> {
  @service declare authenticator: AuthenticatorService;

  get currentUserHasUpvoted() {
    return this.args.solution.currentUserUpvotes.length > 0;
  }

  @action
  handleClick() {
    if (this.currentUserHasUpvoted) {
      this.args.solution.unvote({});
    } else {
      this.args.solution.upvote(this.args.metadata || {});
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'CoursePage::CourseStageStep::CommunitySolutionCard::UpvoteButton': typeof UpvoteButtonComponent;
  }
}
